import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Globe, Building2, Users } from 'lucide-react';
interface InvestorSlide3Props {
  isDark?: boolean;
}
export function InvestorSlide3({
  isDark = false
}: InvestorSlide3Props) {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  return <motion.div className="h-full w-full overflow-y-auto overflow-x-hidden" variants={containerVariants} initial="hidden" animate="visible" data-id="element-246">
      <div className="min-h-full flex flex-col justify-center max-w-6xl mx-auto px-6 sm:px-12 py-20 sm:py-24" data-id="element-247">
        <motion.div variants={itemVariants} className="mb-12 sm:mb-16 text-center" data-id="element-248">
          <h1 className={`text-3xl sm:text-5xl font-bold mb-6 sm:mb-8 tracking-tight ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-249">
            The Opportunity
          </h1>
          <p className={`text-lg sm:text-2xl max-w-3xl mx-auto ${isDark ? 'text-white/80' : 'text-heliona-text-gray'}`} data-id="element-250">
            The intersection of leadership development and mental wellness is
            underserved—we own this category.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 sm:gap-10 mb-16 sm:mb-20" data-id="element-251">
          {/* TAM */}
          <motion.div variants={itemVariants} className={`relative overflow-hidden rounded-3xl p-8 sm:p-10 text-center ${isDark ? 'bg-heliona-navy/40 border border-white/10' : 'bg-heliona-navy/5 border border-heliona-navy/10'}`} data-id="element-252">
            <div className="absolute top-0 right-0 p-4 opacity-10" data-id="element-253">
              <Globe className="w-24 h-24" data-id="element-254" />
            </div>
            <h3 className={`text-sm font-bold uppercase tracking-wider mb-2 ${isDark ? 'text-white/60' : 'text-heliona-text-gray'}`} data-id="element-255">
              TAM
            </h3>
            <div className={`text-4xl sm:text-5xl font-bold mb-4 ${isDark ? 'text-white' : 'text-heliona-navy'}`} data-id="element-256">
              $50B+
            </div>
            <p className={`text-sm sm:text-base ${isDark ? 'text-white/80' : 'text-heliona-text-gray'}`} data-id="element-257">
              Global Leadership Development Market
            </p>
          </motion.div>

          {/* SAM */}
          <motion.div variants={itemVariants} className={`relative overflow-hidden rounded-3xl p-8 sm:p-10 text-center transform scale-105 shadow-xl z-10 ${isDark ? 'bg-heliona-mint/10 border border-heliona-mint/30' : 'bg-heliona-mint/10 border border-heliona-mint/30'}`} data-id="element-258">
            <div className="absolute top-0 right-0 p-4 opacity-10" data-id="element-259">
              <Building2 className="w-24 h-24 text-heliona-mint-dark" data-id="element-260" />
            </div>
            <h3 className={`text-sm font-bold uppercase tracking-wider mb-2 ${isDark ? 'text-heliona-mint' : 'text-heliona-mint-dark'}`} data-id="element-261">
              SAM
            </h3>
            <div className={`text-4xl sm:text-5xl font-bold mb-4 ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-262">
              $12B
            </div>
            <p className={`text-sm sm:text-base ${isDark ? 'text-white/80' : 'text-heliona-text-gray'}`} data-id="element-263">
              Enterprise Leadership Wellness in North America
            </p>
          </motion.div>

          {/* SOM */}
          <motion.div variants={itemVariants} className={`relative overflow-hidden rounded-3xl p-8 sm:p-10 text-center ${isDark ? 'bg-heliona-orange/10 border border-heliona-orange/20' : 'bg-heliona-orange/5 border border-heliona-orange/20'}`} data-id="element-264">
            <div className="absolute top-0 right-0 p-4 opacity-10" data-id="element-265">
              <Users className="w-24 h-24 text-heliona-orange" data-id="element-266" />
            </div>
            <h3 className={`text-sm font-bold uppercase tracking-wider mb-2 ${isDark ? 'text-heliona-orange' : 'text-heliona-orange'}`} data-id="element-267">
              SOM
            </h3>
            <div className={`text-4xl sm:text-5xl font-bold mb-4 ${isDark ? 'text-white' : 'text-heliona-charcoal'}`} data-id="element-268">
              $2.5B
            </div>
            <p className={`text-sm sm:text-base ${isDark ? 'text-white/80' : 'text-heliona-text-gray'}`} data-id="element-269">
              Mid-market organizations with 50-500 people leaders
            </p>
          </motion.div>
        </div>
      </div>
    </motion.div>;
}